module.exports = __webpack_public_path__ + "static/media/selectedRecipts.21b0178b.svg";